<template>
  <div class="module-sub-media">
    <div class="module-sub-media-img" :style="imgStyle" :class="imgClass">
      <div v-if="imgText" class="text">{{imgText}}</div>
    </div>
    <div class="module-sub-media-body">
      <div class="module-sub-media-body-name">{{data.name}}</div>
      <div class="module-sub-media-body-value">{{data.value}}</div>
    </div>
    <div class="module-sub-media-label-wrap">
      <CaseLabel :type="typeLabel">{{data.label}}</CaseLabel>
    </div>
  </div>
</template>

<script>
import { CaseLabel } from '@/components'
export default {
  components: {
    CaseLabel
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    isOdd () {
      return this.data.index % 2
    },
    imgClass () {
      if (this.isOdd) {
        return 'odd'
      }
      return 'even'
    },
    imgStyle () {
      if (this.data.img) {
        return `background-image: url('${this.data.img}')`
      }
      return ''
    },
    imgText () {
      if (this.data.img) {
        return ''
      }
      return this.data.name.substring(0, 1)
    },
    typeLabel () {
      if (this.isOdd) {
        return 0
      }
      return 1
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.module-sub-media {
  position: relative;
  @media (--mediaPc) {
    min-height: 65px; /* 48 + 12 + 12 */
    padding: 32px 53px;
  }
  @media (--mediaMobile) {
    min-height: calc(120px / var(--scaleMobile));
    padding-top: calc(30px / var(--scaleMobile));
    padding-bottom: calc(30px / var(--scaleMobile));
    padding-left: 40px;
    padding-right: calc(32px / var(--scaleMobile));
  }
  & .module-sub-media-img {
    position: absolute;
    width: 50%;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    text-align: center;
    font-weight: bold;
    @media (--mediaPc) {
      width: 65px;
      height: 65px;
      font-size: var(--textSize1);
      border-radius: var(--borderRadius1);
    }
    @media (--mediaMobile) {
      width: calc(120px / var(--scaleMobile));
      height: calc(120px / var(--scaleMobile));
      font-size: var(--textSize1Mobile);
      border-radius: var(--borderRadius1Mobile);
    }
    & .text {
      padding-top: 22px;
    }
    &.odd {
      background-color: var(--labelColorOdd);
      color: var(--colorMain);
    }
    &.even {
      background-color: var(--labelColorEven);
      color: var(--colorOrange);
    }
  }
  & .module-sub-media-body {
    line-height: 1.1rem;
    @media (--mediaPc) {
      margin-left: calc(40px + 48px);
      margin-right: calc(77px + 105px + 44px - 53px);
    }
    @media (--mediaMobile) {
      margin-left: calc(120px / var(--scaleMobile) + 15px);
    }
    & .module-sub-media-body-name {
      word-break: break-all;
      font-weight: bold;
      margin-bottom: 14px;
      @media (--mediaPc) {
        font-size: var(--textSize3);
      }
      @media (--mediaMobile) {
        font-size: var(--textSize3Mobile);
        margin-right: calc(180px / var(--scaleMobile));
      }
    }
    & .module-sub-media-body-value {
      word-break: break-all;
      color: var(--colorGray0);
    }
  }
  & .module-sub-media-label-wrap {
    position: absolute;
    @media (--mediaPc) {
      top: 32px;
      right: 53px;
    }
    @media (--mediaMobile) {
      top: calc(22px / var(--scaleMobile));
      right: calc(32px / var(--scaleMobile));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Media.vue